import React, { Fragment, useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from "@mui/material";
import TableContainer from "../../../Components/TableContainer/TableContainer";
import PROFILE_PHOTO_USER from '../../../Assets/Images/Common/avtar.png'
import CustomAction from '../../../Components/CustomAction/CustomAction';
import AxiosInstance from '../../../Config/AxiosInstance';
import APILIST from '../../../Config/ApiList';
import Constant from '../../../Utils/Constant';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import AddBlogCategory from './AddBlogCategory';
const BlogCategory = () => {
  // const pageSize = 30;
  // const [page, setPage] = useState(0);
  // const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [BlogCategoryList, setBlogCategoryList] = useState([]);
  const [typeCheck, setTypeCheck] = useState(null);
  const [showBlogCategoryModel, setShowBlogCategoryModel] = useState(false);
  const [editBlogCategoryData, setEditBlogCategoryData] = useState(null);
  const columns = [
    { field: "rowid", headerName: "Sr.No.", minWidth: 100, },
    {
      field: "category_name",
      headerName: "Category Name",
      flex:1,
      renderCell: (params) => (params?.row?.category_name ? params?.row?.category_name : "--")
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", gap: "2rem" }}>
            <CustomAction
              showDelete={true}
              showEdit={true}
              isEdit={() => {
                handleEditPartnerModel(params?.row)
              }}
              isDelete={() => handleDeleteBlogCategory(params?.row?.id)}
            />
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    getBlogCategoryList();
  }, []);
  const getBlogCategoryList = async () => {
    setIsLoading(true);
    try {
      const response = await AxiosInstance.get(APILIST.GET_BLOG_CATEGORY);
      if (response && response?.data?.s) {
        const Rowdata = response?.data?.r?.map((data, i) => ({
          rowid: i + 1,
          ...data,
        }));
        setBlogCategoryList(Rowdata);
      } else {
        setBlogCategoryList([]);
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  }
  const handleEditPartnerModel = (partnerData) => {
    setTypeCheck('EDIT');
    setShowBlogCategoryModel(true);
    setEditBlogCategoryData(partnerData)
  }
  const handleOnSubmit = () => {
    setTypeCheck(null);
    getBlogCategoryList();
    setShowBlogCategoryModel(false);
  }
  const handleDeleteBlogCategory = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Blog Category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          id: id,
          status: 0,
        };
        try {
          const response = await AxiosInstance.post(
            APILIST.UPDATE_DELETE_BLOG_CATEGORY,
            params
          );
          if (response?.data?.s === 1) {
            getBlogCategoryList();
            toast.success("Blog Category Deleted Sucessfully !.");
          }
        } catch (error) {
          toast.error("Failed to delete blog category. Please try again.");
        }
      }
    });
  };
  return (
    <Fragment>
      <Box sx={{
        width: '100%',
        padding: '15px'
      }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: '16px'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "20px", md: "30px" },
              fontWeight: "500",
              paddingBottom: "10px",
              fontFamily: "Outfit",
            }}
          >
            Blog Category Management
          </Typography>
          <Button
            sx={{
              width: "200px",
              borderRadius: "15px",
              textTransform: "none",
              fontSize: "16px",
              background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
              color: "black",
              padding: "0",
              margin: "0",
              height: '51px',
              "&:hover": {
                background: "linear-gradient(180deg, #B191FF 0%, #D0BCFF 100%)",
                color: "black",
              },
              fontFamily: "Outfit",
            }}
            onClick={() => setShowBlogCategoryModel(true)}
          >
            Add Blog Cateogry
          </Button>
        </Box>
        <Box sx={{ padding: "24px 0px 24px 0px", borderTop: '1px solid #0000003D' }}>
          <Box sx={{ padding: "24px 0px 24px 0px" }}>
            <TableContainer
              rows={BlogCategoryList}
              columns={columns}
              // pageSize={pageSize}
              loading={isLoading}
              // page={page}
              // totalCount={count}
              // handlePageChange={handlePageChange}
              isPagination={false}
            />
          </Box>
        </Box>
      </Box>
      <AddBlogCategory
        open={showBlogCategoryModel}
        onClose={() => { setShowBlogCategoryModel(false); setTypeCheck(null); setEditBlogCategoryData(null)}}
        typeCheck={typeCheck}
        editBlogCategoryData={editBlogCategoryData}
        handleOnSubmit={handleOnSubmit}
        handleOnClose={() => { setShowBlogCategoryModel(false); setTypeCheck(null); setEditBlogCategoryData(null) }}
      />
    </Fragment>
  );
};

export default BlogCategory;
